<template>
  <div class="content">
    <div class="gift">
      <div class="gift-list">
        <div class="list-hd">
          <ul class="tab-box">
            <li v-bind:class="{ cur: activeIndex === 0 }" @click="changeTab(0)">
              全部礼品
            </li>
            <li v-bind:class="{ cur: activeIndex === 1 }" @click="changeTab(1)">
              待发货<i
                class="icon icon-tip"
                v-if="activeIndex !== 1 && amount_20 !== 0"
                >{{ amount_20 }}</i
              >
            </li>
            <li v-bind:class="{ cur: activeIndex === 2 }" @click="changeTab(2)">
              待审核<i
                class="icon icon-tip"
                v-if="activeIndex !== 2 && amount_30 !== 0"
                >{{ amount_30 }}</i
              >
            </li>
          </ul>
          <div class="blank-box"></div>
          <a
            class="btn-item btn-history"
            href="/Rccl.RewardPoint/RewardPoints/MyGift"
            >礼品券兑换历史记录 ></a
          >
        </div>
        <div class="list-bd">
          <div class="list-item">
            <ul class="fix">
              <li class="des-item">礼品详情</li>
              <li class="des-item">创建时间</li>
              <li class="des-item">活动渠道</li>
              <li class="des-item">兑礼积分</li>
              <li class="des-item">状态</li>
              <li class="des-item">状态/操作</li>
            </ul>
          </div>
          <div class="show-wrap" v-if="giftList.length > 0">
            <div class="show-box">
              <ul>
                <li
                  v-for="(item, index) in giftList"
                  :key="item.Id"
                  :data-index="index"
                >
                  <div class="des-item">
                    <div class="pic-box">
                      <img
                        :src="item.OrderItemModels[0].ImageUrl"
                        :alt="item.OrderItemModels[0].Name"
                      />
                    </div>
                    <div class="text-box">
                      <h3 class="el">{{ item.OrderItemModels[0].Name }}</h3>
                      <p
                        v-if="
                          item.OrderItemModels[0].BenefitsProductType !== 20
                        "
                      >
                        兑换编号：{{ item.SerialNumber }}
                      </p>
                      <p v-else>ID：{{ item.SerialNumber }}</p>
                    </div>
                  </div>
                  <div class="des-item">
                    <p>
                      <span class="black">{{
                        item.CreatedTime.replace(/\:/g, "/")
                      }}</span>
                    </p>
                  </div>
                  <div class="des-item">
                    <p>
                      <span
                        class="red"
                        v-bind:class="{
                          finished: checkStatus(
                            item.ApprovalStatus,
                            item.ShippingStatus,
                            item.OrderStatus,
                            item.OrderItemModels[0].ProductNature
                          ).isFinish,
                        }"
                        >{{ item.ChannelName }}</span
                      >
                    </p>
                  </div>
                  <div class="des-item">
                    <span
                      class="red num"
                      v-bind:class="{
                        finished: checkStatus(
                          item.ApprovalStatus,
                          item.ShippingStatus,
                          item.OrderStatus,
                          item.OrderItemModels[0].ProductNature
                        ).isFinish,
                      }"
                      v-if="item.OrderItemModels[0].BenefitsProductType !== 20"
                      >{{
                        item.OrderItemModels[0].UnitPrice *
                        item.OrderItemModels[0].Quantity
                      }}</span
                    >
                    <span class="red" v-else>无</span>
                  </div>
                  <div class="des-item">
                    <p>
                      <span
                        class="cur"
                        v-bind:class="{
                          finished: checkStatus(
                            item.ApprovalStatus,
                            item.ShippingStatus,
                            item.OrderStatus,
                            item.OrderItemModels[0].ProductNature
                          ).isFinish,
                        }"
                        >{{
                          checkStatus(
                            item.ApprovalStatus,
                            item.ShippingStatus,
                            item.OrderStatus,
                            item.OrderItemModels[0].ProductNature
                          ).text
                        }}</span
                      >
                    </p>
                  </div>
                  <div class="des-item">
                    <div class="aside-box">
                      <a
                        class="btn-item btn-address"
                        href="javascript: void(0)"
                        v-if="
                          item.IsShowShipmentAddress && !item.IsShowFillAddress
                        "
                        @click="seeShipment(index)"
                        >收件地址</a
                      >
                      <a
                        class="btn-item btn-logistics"
                        href="javascript: void(0)"
                        v-if="item.IsShowLogistics"
                        @click="showLogistics(item.Shipment, $event)"
                        >查看物流</a
                      >
                      <a
                        class="btn-item btn-exchange"
                        href="javascript: void(0)"
                        v-if="item.IsShowExchangeInfo"
                        @click="
                          showExchangeInfo(item.OrderItemModels[0], $event)
                        "
                        >兑礼信息</a
                      >
                      <a
                        class="btn-item btn-use"
                        :href="item.OrderItemModels[0].UseUrl"
                        v-if="item.IsShowUse"
                        >立即使用</a
                      >
                      <a
                        class="btn-item btn-fill"
                        href="javascript: void(0)"
                        v-if="item.IsShowFillAddress"
                        @click="goNext(item)"
                        >填写地址</a
                      >
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="page-num fix">
              <Page
                class="r"
                :current="pageIndex"
                :size="pageSize"
                :total="total"
                @on-change="changePage"
              ></Page>
            </div>
          </div>
          <div class="blank-tip" v-else>
            <div class="tip-box">
              <i class="icon icon-blank"></i>
              <p>您还没有任何兑换记录哦！</p>
              <router-link
                tag="a"
                class="btn-item btn-obtain hvc"
                to="/member/shop/index"
                >去兑换</router-link
              >
            </div>
          </div>
        </div>
        <div
          class="info-layer"
          v-if="isShowLayer"
          @click.self="close"
          @mousewheel="preventEvent($event)"
        >
          <div
            class="layer-wrap"
            :style="`top: ${offsetTop}; left: ${offsetLeft};`"
          >
            <div class="layer-title">
              <i class="icon icon-line"></i>
              <h3>{{ infoTitle }}</h3>
            </div>
            <div class="layer-content">
              <div class="info-item">{{ item_01 }}：{{ item_01_detail }}</div>
              <div class="info-item fix" v-if="item_02 || item_03">
                <span class="l">{{ item_02 }}：{{ item_02_detail }}</span>
                <div class="item-aside l" v-if="item_03">
                  <i class="icon icon-line-black"></i>
                  {{ item_03 }} {{ item_03_detail }}
                </div>
              </div>
            </div>
            <!--<a class="btn-item btn-close" href="javascript: void(0)" @click="close"></a>-->
          </div>
        </div>
        <div
          class="receive-layer"
          v-if="isReceiveShow"
          @mousewheel="preventEvent($event)"
        >
          <div class="layer-wrap">
            <div class="layer-title">查看收件地址</div>
            <div class="layer-content">
              <ul>
                <li>
                  <span class="grey"><i>收</i><i>件</i><i>人</i></span
                  ><em>：</em>{{ receiveInfo.RecipientName }}
                </li>
                <li>
                  <span class="grey">手机号码</span><em>：</em
                  >{{ receiveInfo.PhoneNumber }}
                </li>
                <li>
                  <span class="grey">电子邮箱</span><em>：</em
                  >{{ receiveInfo.Email }}
                </li>
                <li>
                  <span class="grey">所在地区</span><em>：</em
                  >{{receiveInfo.City || ""}}
                </li>
                <li>
                  <span class="grey">详细地址</span><em>：</em
                  >{{ receiveInfo.Address }}
                </li>
              </ul>
            </div>
            <a
              class="btn-item btn-close"
              href="javascript: void(0)"
              @click="closeReceiveLayer"
              >关闭</a
            >
            <a
              class="icon icon-close"
              href="javascript: void(0)"
              @click="closeReceiveLayer"
            ></a>
          </div>
        </div>
      </div>
    </div>
    <Loading :loading="loading"></Loading>
    <FillLayer
      :isShow="isShowFillLayer"
      @on-select="selectData"
      @on-close="closeFillLayer"
      @on-submit="submitInfo"
    >
      <input
        class="form-item item-name"
        type="text"
        v-model="userName"
        slot="userName"
        placeholder="收件人"
      />
      <input
        class="form-item item-tel"
        type="text"
        v-model="userTel"
        slot="userTel"
        placeholder="手机号码"
      />

      
      
      
      <input
        class="form-item item-district"
        type="text"
        v-model="userDis"
        slot="userDistrict"
        placeholder="所在地区"
        readonly
      />
      <input
        class="form-item item-address"
        type="text"
        v-model="userAdd"
        slot="userAddress"
        placeholder="详细地址"
      />

      <input
        class="form-item item-address"
        type="text"
        v-model="userEmail"
        slot="userEmail"
        placeholder="电子邮箱"
      />
    </FillLayer>
    <FillNum
      :isShow="isShowFillNum"
      @on-close="closeFillNum"
      @on-submit="submitNum"
    >
      <input
        class="form-item item-num"
        type="text"
        v-model="accountNum"
        slot="accountNum"
        placeholder="请填写需要充值的手机号"
        v-if="
          product.VirtualProductType === 10 || product.VirtualProductType === 20
        "
      />
      <input
        class="form-item item-num"
        type="text"
        v-model="accountNum"
        slot="accountNum"
        placeholder="请填写需要充值的账号"
        v-else
      />
    </FillNum>
    <Message
      :type="messageType"
      :isShow="isShowMessage"
      :tip="messageTip"
      @on-close="closeMessage"
      @on-result="showResult"
    ></Message>
  </div>
</template>

<script>
import axios from "@/libs/api.request";
import {
  checkTel,
  checkEmail,
  dateFormat,
  combineObject,
  urlSearchToObject,
} from "@/libs/tools";
import Page from "@/components/page";
import Loading from "@/components/loading";
import Message from "@/components/message";
import FillLayer from "@/components/fill-info";
import FillNum from "@/components/fill-num";
import { mapMutations } from "vuex";
export default {
  name: "giftList",
  components: {
    Page,
    Loading,
    FillLayer,
    Message,
    FillNum,
  },
  data: () => {
    return {
      state: 10,
      pageSize: 10,
      pageIndex: 1,
      total: 0,
      loading: false,
      amount_20: 0,
      amount_30: 0,
      giftList: [],
      activeIndex: 0,
      isShowLayer: false,
      offsetTop: 0,
      offsetLeft: 0,
      infoTitle: "",
      item_01: "",
      item_01_detail: "",
      item_02: "",
      item_02_detail: "",
      item_03: "",
      item_03_detail: "",
      isReceiveShow: false,
      receiveInfo: {},
      isShowMessage: false,
      messageType: "", // success || examine || confirm || error
      messageTip: "",
      isShowFillNum: false,
      isShowFillLayer: false,
      product: {},
      orderId: "",
      accountNum: "",
      userName: "",
      userTel: "",
      userEmail: "",
      userDis: "",
      userAdd: "",
      userProvince: "",
      userCity: "",
      userDistrictCounty: "",
    };
  },
  async mounted() {
    this.loading = true;

    this.storeToken();

    const isReward = await this.checkCustomerInfo();
    if (!isReward) {
      let href = window.location.href;
      window.location.href = `/Rccl.UserCenter/CustomerInfo/SignUpReward?returnUrl=${encodeURIComponent(
        href
      )}`;
    }

    this.getUserLevelPrivilege().then((res) => {
      this.storeInfo(res.customerInfo);
      this.storePrivilegeList(res.privilegeList);
    });

    this.infiniteHandler(this.state).then((res) => {
      this.giftList = res.data.rows;
      this.total = res.data.totalNum;
    });
    this.infiniteHandler(20).then((res) => {
      this.amount_20 = res.data.totalNum;
    });
    this.infiniteHandler(30).then((res) => {
      this.amount_30 = res.data.totalNum;

      this.loading = false;
    });
  },
  methods: {
    ...mapMutations(["storeInfo", "storePrivilegeList"]),
    storeToken() {
      let token = urlSearchToObject().token;
      let cookieToken = this.$store.state.user.token;
      if (!token && !cookieToken) {
        let href = window.location.href;
        window.location.href = `/Rccl.Campaign/MemberCenter/Auth?redirectUrl=${encodeURIComponent(
          href
        )}`;
      }
      if (token && token !== cookieToken) {
        this.setToken(token);
      }
    },
    formatTime(time) {
      let timestamp = new Date(time).getTime();
      return dateFormat(timestamp, "YYYY-MM-DD");
    },
    close() {
      this.isShowLayer = false;
      this.clearData();
    },
    closeReceiveLayer() {
      this.isReceiveShow = false;
      this.receiveInfo = {};
    },
    preventEvent(e) {
      e.preventDefault();
      return false;
    },
    clearData() {
      this.infoTitle = "";
      this.item_01 = "";
      this.item_01_detail = "";
      this.item_02 = "";
      this.item_02_detail = "";
      this.item_03 = "";
      this.item_03_detail = "";
    },
    showLogistics(shipment, e) {
      this.isShowLayer = true;
      this.infoTitle = "查看物流信息";
      this.item_01 = "物流公司";
      this.item_01_detail = shipment.LogisticsCompanies;
      this.item_02 = "物流单号";
      this.item_02_detail = shipment.TrackingNumber;

      this.showPos(e);
    },
    showExchangeInfo(order, e) {
      this.isShowLayer = true;
      this.infoTitle = "查看兑礼信息";
      this.item_01 = "礼品名称";
      this.item_01_detail = order.Name;
      // 10手机号 | 20流量 | 30卡密 | 40账号直充 | 50串码 | 60电影票
      if (order.VirtualProductType === 10 || order.VirtualProductType === 20) {
        this.item_02 = "";
        this.item_02_detail = '';
      } else if (order.VirtualProductType === 40) {
        this.item_02 = "";
        this.item_02_detail = '';
      } else if (order.VirtualProductType === 30) {
        this.item_02 = "礼品信息";
        this.item_02_detail = "账号 " + order.Account;
        this.item_03 = "密码";
        this.item_03_detail = order.Password;
      } else if (
        order.VirtualProductType === 50 ||
        order.VirtualProductType === 60
      ) {
        this.item_02 = "礼品兑换码";
        this.item_02_detail = order.CodeData;
      }

      this.showPos(e);
    },
    showPos(e) {
      let $target = e.target;
      let _scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      this.isShowLayer = true;
      this.offsetTop = $target.offsetTop - _scrollTop + "px";
      this.offsetLeft = $target.offsetLeft + "px";
    },
    checkStatus(ApprovalStatus, ShippingStatus, OrderStatus, ProductNature) {
      switch (ApprovalStatus) {
        case 20:
          return {
            text: "待审核（7天内反馈）",
            isFinish: false,
          };
        case 40:
          return {
            text: "兑礼失败",
            isFinish: false,
          };
        default:
          switch (ShippingStatus) {
            case 20:
              return {
                text: "待发货",
                isFinish: false,
              };
            case 30:
              return {
                text: "已发货",
                isFinish: true,
              };
            case 40:
              return {
                text: "已收货",
                isFinish: true,
              };
            default:
              switch (OrderStatus) {
                case 10:
                  return {
                    text: "待审核（7天内反馈）",
                    isFinish: false,
                  };
                case 20:
                  return {
                    text: "待发货",
                    isFinish: false,
                  };
                case 30:
                  return {
                    text: "已发货",
                    isFinish: true,
                  };
                case 40:
                  return {
                    text: "兑礼失败",
                    isFinish: false,
                  };
                case 50:
                  switch (ProductNature) {
                    case 20:
                      return {
                        text: "已发放",
                        isFinish: true,
                      };
                    default:
                      return {
                        text: "兑礼完成",
                        isFinish: true,
                      };
                  }
                case 60:
                  return {
                    text: "正在处理",
                    isFinish: false,
                  };
              }
          }
      }
    },
    infiniteHandler(state) {
      return new Promise((resolve) => {
        axios
          .request({
            url: "/pro/Store/CMOrder/List",
            method: "post",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
            data: {
              state,
              pageSize: this.pageSize,
              pageIndex: this.pageIndex,
            },
          })
          .then((res) => {
            let data = res.data;
            if (data.errCode === 0) {
              resolve(data);
            } else if (data.errCode === 1000) {
              window.console.log("失败");
            } else {
              window.console.log("系统错误");
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
    changeTab(index) {
      this.activeIndex = index;
      this.state = (index + 1) * 10;
      this.giftList = [];
      this.pageIndex = 1;
      this.total = 0;
      this.loading = true;
      this.infiniteHandler(this.state).then((res) => {
        this.giftList = res.data.rows;
        this.total = res.data.totalNum;
        this.loading = false;
      });
      if (this.state === 20) {
        this.infiniteHandler(20).then((res) => {
          this.amount_20 = res.data.totalNum;
        });
      }
      if (this.state === 30) {
        this.infiniteHandler(30).then((res) => {
          this.amount_30 = res.data.totalNum;
        });
      }
    },
    changePage(page) {
      this.pageIndex = page;
      this.loading = true;
      this.infiniteHandler(this.state).then((res) => {
        this.giftList = res.data.rows;
        this.loading = false;
      });
    },
    seeShipment(index) {
      this.receiveInfo = this.giftList[index];
      this.isReceiveShow = true;
    },
    goNext(item) {
      this.product = item.OrderItemModels[0];
      this.orderId = item.Id;
      let giftType = this.product.GiftType;
      let virtualProductType = this.product.VirtualProductType;
      if (giftType === 10 && virtualProductType !== 50) {
        this.isShowFillNum = true;
      }
      if (giftType === 20) {
        this.isShowFillLayer = true;
      }
    },
    closeFillLayer() {
      this.isShowFillLayer = false;
    },
    selectData(data) {
      this.userProvince = data.province;
      this.userCity = data.city;
      this.userDistrictCounty = data.district ? data.district : "";
      this.userDis = `${this.userProvince} ${this.userCity} ${this.userDistrictCounty}`;
    },
    submitInfo() {
      if (this.userName === "") {
        this.messageType = "error";
        this.messageTip = "出错啦<br>未填写收件人姓名";
        this.isShowMessage = true;
        return false;
      }
      if (this.userTel === "") {
        this.messageType = "error";
        this.messageTip = "出错啦<br>未填写收件人手机号码";
        this.isShowMessage = true;
        return false;
      }
      if (!checkTel(this.userTel)) {
        this.messageType = "error";
        this.messageTip = "出错啦<br>收件人手机号码有误";
        this.isShowMessage = true;
        return false;
      }

      // 邮箱 验证 start
      if (this.userEmail === "") {
        this.messageType = "error";
        this.messageTip = "出错啦<br>未填写收件人电子邮箱";
        this.isShowMessage = true;
        return false;
      }
      if (!checkEmail(this.userEmail)) {
        this.messageType = "error";
        this.messageTip = "出错啦<br>收件人电子邮箱有误";
        this.isShowMessage = true;
        return false;
      }
      if (this.userEmail.length > 64) {
        this.messageType = "error";
        this.messageTip = "出错啦<br>收件人电子邮箱长度不能超过64位";
        this.isShowMessage = true;
        return false;
      }
      // 邮箱 验证 end

      if (this.userDis === "") {
        this.messageType = "error";
        this.messageTip = "出错啦<br>未选择所在地区";
        this.isShowMessage = true;
        return false;
      }
      if (this.userAdd === "") {
        this.messageType = "error";
        this.messageTip = "出错啦<br>未填写详细地址";
        this.isShowMessage = true;
        return false;
      }
      if (this.checkAddress(this.userAdd)) {
        this.messageType = "error";
        this.messageTip = "出错啦<br>请填写正确的地址信息";
        this.isShowMessage = true;
        return false;
      }
      let data = {
        name: this.userName,
        email: this.userEmail,
        mob: this.userTel,
        province: this.userProvince,
        city: this.userCity,
        districtCounty: this.userDistrictCounty,
        address: this.userAdd,
        zipCode: "",
      };
      // 显示loading
      this.loading = true;
      this.updatePlace(combineObject(data, { orderId: this.orderId })).then(
        (res) => {
          if (res.errCode === 0) {
            this.messageType = "success";
            this.messageTip = "提交成功<br>礼品将会尽快发出！";
            this.isShowMessage = true;
          }
        }
      );
    },
    closeFillNum() {
      this.isShowFillNum = false;
    },
    submitNum() {
      if (this.accountNum === "" && this.product.VirtualProductType !== 50) {
        this.messageType = "error";
        this.messageTip = "出错啦<br>未填写需要充值的账号";
        this.isShowMessage = true;
        return false;
      }
      if (
        !checkTel(this.accountNum) &&
        (this.product.VirtualProductType === 10 ||
          this.product.VirtualProductType === 20)
      ) {
        this.messageType = "error";
        this.messageTip = "出错啦<br>填写手机号不正确";
        this.isShowMessage = true;
        return false;
      }

      //显示loading
      this.loading = true;
      this.updatePlace({
        orderId: this.orderId,
        accountnum: this.accountNum,
      }).then((res) => {
        if (res.errCode === 0) {
          this.messageType = "success";
          this.messageTip = "提交成功<br>请在48小时内查收短信通知";
          this.isShowMessage = true;
        }
      });
    },
    closeMessage() {
      this.isShowMessage = false;
    },
    showResult() {
      location.reload();
    },
    checkAddress(address) {
      let reg = /^[0-9a-zA-Z]+$/;
      return reg.test(address);
    },
    updatePlace(data) {
      return new Promise((resolve) => {
        axios
          .request({
            url: "/pro/Store/CMOrder/UpdateAddress",
            method: "post",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
            data: data,
          })
          .then((res) => {
            this.isShowFillLayer = false;
            this.isShowFillNum = false;
            this.loading = false;
            let _data = res.data;
            if (_data.errCode === 0 || _data.errCode === 10) {
              resolve(_data);
            } else if (_data.errCode === 1000) {
              window.console.log("失败");
              this.messageType = "error";
              this.messageTip = "出错啦<br>系统开小差了，晚点再回来看看吧！";
              this.isShowMessage = true;
            } else if (_data.errCode === 1100) {
              window.console.log("系统错误");
              this.messageType = "error";
              this.messageTip = "出错啦<br>系统开小差了，晚点再回来看看吧！";
              this.isShowMessage = true;
            } else {
              this.messageType = "error";
              this.messageTip = `出错啦<br>${_data.errMsg}!`;
              this.isShowMessage = true;
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
    getUserLevelPrivilege() {
      return new Promise((resolve) => {
        axios
          .request({
            url: "/api/CustomerInfo/ApiGetUserLevelPrivilege",
            method: "post",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
            data: {
              loyaltyId: this.$store.state.user.loyaltyId,
            },
          })
          .then((res) => {
            let data = res.data;
            if (data.errCode === 0) {
              resolve(data.data);
            } else if (data.errCode === 1000) {
              window.console.log("失败");
            } else {
              window.console.log("系统错误");
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
    checkCustomerInfo() {
      return new Promise((resolve) => {
        axios
          .request({
            url: "/api/CustomerInfo/ApiCheckCustomerInfo",
            method: "post",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
            data: {
              loyaltyId: this.$store.state.user.loyaltyId,
            },
          })
          .then((res) => {
            let data = res.data;
            if (data.errCode === 0) {
              resolve(data.data);
            } else if (data.errCode === 1000) {
              window.console.log("失败");
            } else {
              window.console.log("系统错误");
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.gift {
  padding-bottom: 84px;
  .gift-list {
    border-left: #d5dcdf solid 1px;
    .list-hd {
      position: relative;
      height: 77px;
      .tab-box {
        height: 57px;
        border-bottom: #d5dcdf solid 1px;
        li {
          float: left;
          position: relative;
          width: 158px;
          height: 56px;
          line-height: 56px;
          text-align: center;
          border-right: #d5dcdf solid 1px;
          border-top: #d5dcdf solid 1px;
          background-color: #f3f6f8;
          cursor: pointer;
          &.cur {
            height: 57px;
            border-top: #006ab9 solid 3px;
            background-color: #fff;
            color: #006ab9;
            line-height: 53px;
          }
          .icon-tip {
            display: block;
            position: absolute;
            left: 102px;
            top: 20px;
            width: 16px;
            height: 16px;
            background-color: #ff3022;
            border-radius: 8px;
            font-size: 10px;
            text-align: center;
            color: #fff;
            line-height: 16px;
          }
        }
      }
      .blank-box {
        height: 20px;
        background-color: #fff;
        border-right: #d5dcdf solid 1px;
      }
      .btn-history {
        position: absolute;
        right: 0;
        top: 28px;
        color: #006ab9;
        line-height: 20px;
      }
    }
    .list-bd {
      border-right: #d5dcdf solid 1px;
      border-bottom: #d5dcdf solid 1px;
      background-color: #fff;
      .des-item {
        display: inline-block;
        vertical-align: middle;
        &:nth-child(1) {
          width: 380px;
          text-align: left;
        }
        &:nth-child(2) {
          width: 96px;
          text-align: center;
        }
        &:nth-child(3) {
          width: 96px;
          text-align: center;
        }
        &:nth-child(4) {
          width: 96px;
          text-align: center;
        }
        &:nth-child(5) {
          width: 140px;
          text-align: center;
        }
        &:nth-child(6) {
          width: 96px;
          text-align: center;
        }
      }
      .list-item {
        padding: 0 20px;
        background-color: #f5f5f5;
        ul {
          li {
            line-height: 36px;
          }
        }
      }
      .show-box {
        padding: 0 20px;
        ul {
          li {
            height: 100px;
            border-bottom: #e5e9eb solid 1px;
            font-size: 0;
            &::before {
              content: "";
              display: inline-block;
              vertical-align: middle;
              width: 0;
              height: 100%;
            }
            .des-item {
              font-size: 14px;
              .pic-box {
                display: inline-block;
                vertical-align: middle;
                position: relative;
                width: 101px;
                height: 65px;
                border: #d4dbde solid 1px;
                border-radius: 3px;
                overflow: hidden;
                img {
                  position: absolute;
                  left: 0;
                  top: 50%;
                  width: 100%;
                  transform: translateY(-50%);
                  -webkit-transform: translateY(-50%);
                  -moz-transform: translateY(-50%);
                  -o-transform: translateY(-50%);
                  -ms-transform: translateY(-50%);
                }
              }
              .text-box {
                display: inline-block;
                vertical-align: middle;
                padding-left: 20px;
                h3,
                p {
                  font-size: 14px;
                  line-height: 24px;
                }
              }
              .red {
                color: #ff3022;
              }
              .cur {
                color: #ff3022;
              }
              .num {
                font-weight: bold;
              }
              .finished {
                color: #282b2c;
              }
              .aside-box {
                text-align: center;
                .btn-item {
                  display: inline-block;
                  width: 72px;
                  height: 25px;
                  margin-top: 9px;
                  border: #4a90e2 solid 1px;
                  border-radius: 13px;
                  color: #4a90e2;
                  font-size: 12px;
                  text-align: center;
                  line-height: 25px;
                  &:first-child {
                    margin-top: 0;
                  }
                  &.btn-fill {
                    border: none;
                    background-color: #fbc500;
                    color: #282b2c;
                  }
                }
              }
            }
          }
        }
      }
      .page-num {
        padding: 20px;
      }
      .blank-tip {
        height: 566px;
        padding-top: 100px;
        background-color: #fff;
        .tip-box {
          width: 230px;
          margin: 0 auto;
          text-align: center;
          .icon-blank {
            display: inline-block;
            width: 146px;
            height: 125px;
            background: url("../../../assets/images/blank.png") no-repeat;
            background-size: 100%;
          }
          p {
            margin-top: 30px;
            font-size: 16px;
            color: #919b9f;
            line-height: 20px;
          }
          .btn-obtain {
            width: 135px;
            height: 32px;
            margin: 14px auto;
            border: #53a1df solid 1px;
            border-radius: 16px;
            text-align: center;
            color: #53a1df;
            font-size: 16px;
            line-height: 32px;
          }
        }
      }
    }
    .info-layer {
      position: fixed;
      left: 0;
      top: 0;
      z-index: 999;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      .layer-wrap {
        position: absolute;
        left: 1170px;
        width: 320px;
        padding: 16px 26px;
        margin-left: 52px;
        margin-top: 87px;
        background-color: #fff;
        border: #b4b9bb solid 1px;
        transform: translate(-280px, -56px);
        -webkit-transform: translate(-280px, -56px);
        -moz-transform: translate(-280px, -56px);
        -o-transform: translate(-280px, -56px);
        -ms-transform: translate(-280px, -56px);
        &::after {
          content: "";
          display: block;
          position: absolute;
          right: 34px;
          top: -5px;
          width: 0;
          height: 0;
          border-left: transparent solid 6px;
          border-right: transparent solid 6px;
          border-bottom: #fff solid 6px;
        }
        .layer-title {
          position: relative;
          height: 24px;
          line-height: 24px;
          .icon-line {
            position: absolute;
            left: -7px;
            top: 4px;
            width: 2px;
            height: 16px;
            background-color: #fbc500;
          }
          h3 {
            font-size: 14px;
          }
        }
        .layer-content {
          padding-top: 7px;
          .info-item {
            height: 24px;
            .item-aside {
              height: 100%;
            }
            .icon-line-black {
              display: inline-block;
              vertical-align: middle;
              width: 1px;
              height: 14px;
              margin: 0 4px;
              background-color: #282b2c;
            }
          }
        }
      }
    }
    .receive-layer {
      position: fixed;
      left: 0;
      top: 0;
      z-index: 999;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      .layer-wrap {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 501px;
        height: 344px;
        padding: 26px 30px;
        margin-top: -172px;
        margin-left: -125px;
        background-color: #fff;
        border-radius: 4px;
        .layer-title {
          font-size: 22px;
          line-height: 34px;
        }
        .layer-content {
          padding-top: 20px;
          padding-bottom: 32px;
          li {
            font-size: 16px;
            line-height: 36px;
            .grey {
              color: #919b9f;
            }
            em {
              margin-right: 10px;
              color: #919b9f;
            }
            &:first-child {
              .grey {
                i:nth-child(1) {
                  letter-spacing: 7px;
                }
                i:nth-child(2) {
                  letter-spacing: 8px;
                }
                i:nth-child(3) {
                  letter-spacing: 1px;
                }
              }
            }
          }
        }
        .btn-close {
          display: block;
          width: 100%;
          height: 46px;
          background-color: #fbc500;
          font-size: 16px;
          line-height: 46px;
          text-align: center;
        }
        .icon-close {
          position: absolute;
          right: 10px;
          top: 10px;
          width: 29px;
          height: 29px;
          background: url("../../../assets/images/close.png") no-repeat center
            center #d3dadd;
          background-size: 16px 16px;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>
